import React from 'react'
import { Translation, Translator } from '@morningtrain/react-translations'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import ForEachNormItemCategory from './norms/ForEachNormItemCategory'
import NormItemCategory from './norms/NormItemCategory'
import * as UI from 'ui'
import EditInventoryNormIndexQuantity from 'support/displays/inventory/EditInventoryNormIndexQuantity'
import { ModelWithForm, WhenModel } from '@morningtrain/react-resources'
import { SelectedDepartmentFilter } from 'support/filters'
import NormsPageHeader from './norms/NormsPageHeader'
import NormManagerFields from 'pages/app/inventory/norms/NormManagerFields'
import MountNormsSummarySmartview from 'pages/app/inventory/norms/MountNormsSummarySmartview'
import ConfirmFormChanges from 'support/pipelines/ConfirmFormChanges'

export default function Norms (props) {
  return (
    <AdminPageWithSmartview>
      <Translator namespace='inventory.norms'>
        <ModelWithForm resourceName='inventory.department_norm_index' operationName='read'>
          <SelectedDepartmentFilter />
          <ConfirmFormChanges />
          <MountNormsSummarySmartview />

          <NormManagerFields />

          <WhenModel>
            <NormsPageHeader>
              <UI.ButtonWrap>
                <EditInventoryNormIndexQuantity />
                <UI.SubmitButton>
                  <Translation name='actions.update_index' />
                </UI.SubmitButton>
              </UI.ButtonWrap>
            </NormsPageHeader>
          </WhenModel>
          <UI.CardGroup>
            <ForEachNormItemCategory>
              <NormItemCategory />
            </ForEachNormItemCategory>
          </UI.CardGroup>
        </ModelWithForm>
      </Translator>
    </AdminPageWithSmartview>
  )
}
